<template>
  <div class="answer-history" @scroll="handleScroll">
    <div class="header">
      <TopBar :title="$t('mine.dtls')" />
    </div>
    <div class="content-no-data" v-if="loading">
      <van-loading size="35" />
    </div>
    <div v-else>
      <div v-if="answerHistoryArr.length > 0">
        <div
          class="history-card"
          v-for="(item, index) of answerHistoryArr"
          :key="index"
        >
          <div class="top">
            <div class="history-type">
              <img
                v-if="item.platformType == 1"
                src="@/assets/img/pcHandset.png"
                alt="图片"
              />
              <img
                v-if="item.platformType == 2"
                src="@/assets/img/pc.png"
                alt="图片"
              />
              <img
                v-if="item.platformType == 3"
                src="@/assets/img/handset.png"
                alt="图片"
              />
            </div>
            <div class="history-info">
              <div class="name">{{ item.title }}</div>
              <div class="count">
                {{ $t("wenjuanNum") }} ：{{ item.number }}
              </div>
              <div class="money">
                <div>
                  <img src="@/assets/img/gold.png" alt="图片" />
                  <span> {{ item.finalPoints }} {{ $t("moneyType") }}</span>
                </div>
                <div class="spacing">
                  <img src="@/assets/img/clock.png" alt="" /><span
                    >{{ item.loi }}{{ $t("time") }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="center"></div>
          <div class="bottom">
            <div class="date">
              <img src="@/assets/img/calendar.png" alt="" />
              <span>{{ item.joinDate }}</span>
            </div>
            <div class="status">
              <img src="@/assets/img/status.png" alt="" />
              <span>{{ item.status }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="content-no-data">
        <van-image width="100" height="100" :src="nodataImg" />
      </div>
    </div>
    <div
      class="finished-text"
      v-show="pagebar.currentPage >= pagebar.totalPage"
    >
      <div class="finished-text__line"></div>
      <span class="finished-text__text"> {{ $t("baseline") }}</span>
    </div>

    <div
      style="text-align: center; margin-top: 16px; opacity: 0"
      v-if="answerHistoryArr.length !== 0"
    >
      <van-button type="primary" size="small"
        >{{ $t("getMore") }}...</van-button
      >
    </div>
  </div>
</template>

<script>
import { accountsHistoricalSurveys } from "@/api/api.js";
import { Notify } from "vant";
import TopBar from "@/common/top-bar/index.vue";
import img from "@/assets/img/无数据.png";
import { throttle } from "lodash";

export default {
  name: "AnswerHistory",
  components: {
    TopBar,
  },
  data() {
    return {
      loading: true,
      nodataImg: img,
      imgSrc: "http://www.weopinions.com/images/photo/20220919_56.jpg",
      answerHistoryArr: [],
      pagebar: {
        currentPage: 1,
        pageSize: 15,
        totalPage: 2,
        totalSize: 0,
      },
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    initPage() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        page: 1,
        size: 15,
      };
      accountsHistoricalSurveys(params).then((res) => {
        if (res.code === 200) {
          this.answerHistoryArr = res.data.list;
          this.pagebar = res.data.pagebar;
          console.log("res", res);
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    getMore() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        page: this.pagebar.currentPage + 1,
        size: this.pagebar.pageSize,
      };
      accountsHistoricalSurveys(params).then((res) => {
        if (res.code === 200) {
          this.answerHistoryArr = [...this.answerHistoryArr, ...res.data.list];
          this.pagebar = res.data.pagebar;
        } else {
          this.pagebar.currentPage--;
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    handleScroll: throttle(function (e) {
      const scrollTop = document.querySelector(".answer-history").scrollTop;
      const clientHeight =
        document.querySelector(".answer-history").clientHeight;
      const scrollview = document.querySelector(".answer-history").scrollHeight;
      if (scrollTop + clientHeight >= scrollview - 100) {
        this.getMore();
      }
    }, 500),
  },

  mounted() {
    this.initPage();
    // window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  activated() {},
};
</script>

<style lang="stylus" scoped>
/deep/.answer-history {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  padding-bottom: 20px;

  .wrapper {
    height: 2.5rem;

    .body {
      display: flex;
      justify-content: center;
      margin-top: 20px;

      .card {
        border-radius: 0.2rem;
        width: 90%;
        height: 2.2rem;
        background: #ffffff;
        display: flex;
        align-items: center;
        font-weight: bold;

        .left {
          margin-left: 0.2rem;
        }

        .right {
          width: 100%;
          margin-left: 0.5rem;

          .money {
            color: #C7C7C7;
            display: flex;

            .van-icon {
              color: #F67E3D;
              font-weight: bold;
            }

            div {
              margin-left: 10px;
            }

            margin-bottom: 0.2rem;
          }

          .count {
            color: #C7C7C7;
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
          }

          .date {
            width: 100%;
            font-weight: normal;
            margin-right: 5px;
            display: flex;
            justify-content: space-between;

            div {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }

  .footer {
    padding: 0 0.4rem;
  }

  .content-no-data {
    background: transparent;
    padding: 0.4rem;
    height: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
<style lang="stylus">
.noticeWidth {
  min-width: 40vw;
}
</style>
<style scoped>
.history-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 194px;
  background-color: #fff;
  margin-top: 20px;
}
.history-card .top {
  width: 100%;
  display: flex;
}
.history-type {
  width: 120px;
  height: 120px;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  margin-top: 20px;
}
.history-type img {
  width: 80px;
  height: 80px;
}
.history-info {
  display: flex;
  flex-direction: column;
  margin-left: 17px;
}
.history-info .name {
  height: 16px;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  margin-top: 33px;
}
.history-info .count {
  height: 12px;
  font-size: 12px;
  font-weight: 400;
  color: #959595;
  margin-top: 16px;
}
.history-info .money {
  display: flex;
  margin-top: 20px;
}
.money img {
  width: 16px;
  height: 16px;
}
.money span {
  width: 31px;
  height: 12px;
  font-size: 12px;
  font-weight: 400;
  color: #959595;
  margin-left: 2px;
}
.money .spacing {
  margin-left: 12px;
}
.history-card .center {
  width: 100%;
  height: 0px;
  opacity: 1;
  border: 1px solid #f6f6f6;
  margin-top: 23px;
}
.history-card .bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 31px;
}
.bottom .date img {
  width: 20px;
  height: 20px;
  margin-left: 16px;
}
.bottom .date span {
  height: 13px;
  font-size: 12px;

  font-weight: 400;
  color: #959595;
}
.bottom .status img {
  width: 20px;
  height: 20px;
}
.bottom .status span {
  height: 13px;
  font-size: 12px;
  font-weight: 400;
  color: #959595;
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/answerHistory/AnswerHistory.vue